@import "~@govbr-ds/core/src/components/radio/radio";
@include radio-checked;

:host {
  display: inline-block;

  .br-radio.hidden-label {
    label {
      padding-left: calc(var(--checkbox-size) + var(--surface-width-md) * 2);
      text-indent: -10000px;
      white-space: nowrap;
      width: 0;
    }
  }
}
